<template>
  <form id="msisdn-form">
    <label class="landing-label">
      <span class="label-title">{{ $t('pages.login.labels.name') }}</span>
      <input type="text"
        v-model.trim="username"
        ref="usernameInput"
      >
      <small v-if="user.validation_errors && user.validation_errors.username">
        {{ user.validation_errors.username[0] }}
      </small>
    </label>

    <fieldset class="buttons">
      <button type="button"
              class="main-btn submit-btn phone-number"
              @click="submitForgotPassword"
      >
        <span class="spinner-label">{{ $t('pages.forgotPassword.submit') }}</span>
      </button>
    </fieldset>
  </form>
</template>

<script>
import ForgotPasswordForm from './ForgotPasswordForm';
export default ForgotPasswordForm;
</script>
